// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_L9D","selected":"styles_selected__1r0fN"};